import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../../Config'; // ajustá si la ruta es distinta


export default function StockAdmin() {
  const [productos, setProductos] = useState([]);

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/productos`)
      .then(res => setProductos(res.data))
      .catch(err => console.error('Error al cargar productos:', err));
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">📦 Control de Stock</h1>
      <table className="w-full border table-auto">
        <thead className="bg-gray-100">
          <tr>
            <th className="border p-2">Nombre</th>
            <th className="border p-2">Stock</th>
            <th className="border p-2">Stock Mínimo</th>
            <th className="border p-2">Estado</th>
          </tr>
        </thead>
        <tbody>
          {productos.map(p => (
            <tr key={p.id}>
              <td className="border p-2">{p.nombre}</td>
              <td className="border p-2">{p.descripcion}</td> {/* Aquí debes mostrar stock real si lo tienes */}
              <td className="border p-2">{p.stockMinimo}</td>
              <td className="border p-2 text-center">
                {(parseInt(p.descripcion) || 0) < p.stockMinimo
                  ? <span className="text-red-500 font-semibold">⚠ Bajo</span>
                  : <span className="text-green-600 font-semibold">✔ OK</span>}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
